import { urls } from "app/constants";
import { useApi } from "./index";

export const useApiChatSecret = () =>
  useApi({ url: urls.chatSecrets, method: "get" });
